import { render, staticRenderFns } from "./SeleccionarSujeto.vue?vue&type=template&id=5f211154&"
import script from "./SeleccionarSujeto.vue?vue&type=script&lang=js&"
export * from "./SeleccionarSujeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports